import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackService } from '../../../../shared/services/snack.service';
import { ResponsibleType } from '@shared/interfaces';
import { SummaryReportService } from '../../../../shared/services/summary-report.service';
import { currentReportingPeriod, reportingPeriod } from '../../../../shared/helpers/helpers';
import { FileService } from '@shared/services';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';
import { ISummaryReportForm } from '../../../../shared/interfaces/reports/ISummaryReportForm';

@Component({
    selector: 'app-summary-report-new',
    templateUrl: './summary-report-new.component.html',
    styleUrls: ['./summary-report-new.component.scss'],
    standalone: false
})
export class SummaryReportNewComponent implements OnInit {
    protected formGroup: FormGroup<ISummaryReportForm>;
    protected isSaving: boolean;

    constructor(
        public dialogRef: MatDialogRef<SummaryReportNewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Array<File>,
        private snack: SnackService,
        private summaryReportService: SummaryReportService,
        private fileService: FileService
    ) {}

    ngOnInit(): void {
        this.buildForm();
    }

    protected async createSummaryReport(): Promise<void> {
        this.formGroup.markAllAsTouched();
        if (this.formGroup.invalid) {
            this.snack.openSnackBarError('Form is invalid. Please check your input.');
            return;
        }

        this.isSaving = true;
        const value = this.formGroup.value;

        try {
            const document = value.documents[0];
            value.documents = null;
            const result = await this.summaryReportService.create(value);

            const uploadLink = await this.summaryReportService.getUploadLink(result.id);
            await this.fileService.uploadAttachment(uploadLink?.link, await document.arrayBuffer());

            this.snack.openSnackBarSuccess(`Summary report ${result.id} created successfully.`);
            this.dialogRef.close(true);
        } catch (error) {
            this.snack.openSnackBarError('An error has occurred!');
            throw error;
        }
        this.isSaving = false;
    }

    private buildForm(): void {
        this.formGroup = new FormGroup<ISummaryReportForm>({
            title: new FormControl<string>({ value: null, disabled: false }, Validators.required),
            description: new FormControl<string>({ value: null, disabled: false }, Validators.required),
            responsibleType: new FormControl<ResponsibleType>(
                { value: ResponsibleType.sag, disabled: false },
                Validators.required
            ),
            documents: new FormControl<File[]>({ value: this.data, disabled: false }, Validators.required),
            reportingYear: new FormControl<string>({ value: this.getReportingYear(), disabled: false })
        });
    }

    private getReportingYear(): string {
        const currentDate = new Date();
        let reportingYear: string;
        if (IS_TRS_PROJECT) {
            reportingYear =
                currentDate.getMonth() < 7
                    ? (reportingPeriod() as { label: string; showLabel: string }).label
                    : currentReportingPeriod;
        } else if (IS_PRODUCT_SAFETY_PROJECT) {
            reportingYear = currentDate.getMonth() < 7 ? (reportingPeriod() as string) : currentReportingPeriod;
        }
        return reportingYear;
    }
}
